import React from 'react'

type CardInformationDivProps = {
  disabled: boolean
  children: React.ReactNode
}

export const CardInformationDiv: React.VFC<CardInformationDivProps> = (props) => {
  const disableLabel = (): React.CSSProperties | undefined => {
    if (props.disabled) {
      return {
        color: 'rgb(173, 173, 173)',
      }
    }
  }

  return (
    <div
      className="pl_28"
      style={disableLabel()}
    >
      {props.children}
    </div>
  )
}
